import { render, staticRenderFns } from "./work_order_detail.vue?vue&type=template&id=096bdcc7&scoped=true&"
import script from "./work_order_detail.vue?vue&type=script&lang=js&"
export * from "./work_order_detail.vue?vue&type=script&lang=js&"
import style0 from "./work_order_detail.vue?vue&type=style&index=0&id=096bdcc7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096bdcc7",
  null
  
)

export default component.exports